import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

import { useOverflowEdges } from "./useOverflowEdges";

// Прокручиваемая середина меню между шапкой и подвалом. Системной полосы прокрутки нет:
// в свёрнутом меню она съедала ширину колонки и сдвигала значки. Что меню прокручивается,
// видно по погашенному краю, за которым есть ещё пункты; пункт, до которого дошли
// клавиатурой, встаёт вне погашенного края (`scroll-py`).
export const SidebarContent = ({ className, ...props }: ComponentProps<"div">) => {
  const ref = useOverflowEdges();
  return (
    <div
      ref={ref}
      data-slot="sidebar-content"
      className={cn(
        "flex min-h-0 flex-1 flex-col gap-5.5 overflow-y-auto px-3 py-5 group-data-[state=collapsed]/sidebar:items-center group-data-[state=collapsed]/sidebar:gap-3.5 group-data-[state=collapsed]/sidebar:px-0",
        "scroll-py-8 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
        "[--fade-bottom:0px] [--fade-top:0px] data-overflow-bottom:[--fade-bottom:--spacing(8)] data-overflow-top:[--fade-top:--spacing(8)]",
        "[mask-image:linear-gradient(to_bottom,transparent,black_var(--fade-top),black_calc(100%_-_var(--fade-bottom)),transparent)]",
        className,
      )}
      {...props}
    />
  );
};
